<template>
  <v-container class="fuel-component mt-1 pa-0 pr-2 pl-3">
    <v-row class="pa-0" v-if="!checklistFuelData.notApply">
      <v-col
        v-if="isEditChecklist"
        align-self="center"
        class="pa-3 fuel-component_not-apply text-center"
        cols="2"
        @click.stop="checklistFuelData.notApply = !checklistFuelData.notApply"
        >No aplica</v-col
      >
      <v-col :cols="isEditChecklist ? '10' : '12'" class="pa-0 pl-2 pr-3">
        Nivel de combustible
        <div>
          <v-slider
            :disabled="accessToEdit"
            :readonly="!isEditChecklist"
            :hide-details="isEditChecklist"
            v-model="checklistFuelData.value"
            :tick-labels="labels"
            :max="4"
            step="1"
            ticks="always"
            tick-size="5"
            :color="isEditChecklist ? 'accent' : 'primary'"
            track-color="gray"
          ></v-slider>
        </div>
      </v-col>
    </v-row>
    <v-row class="pa-3" v-else no-gutters>
      <v-col align-self="center" class="pa-2" cols="11" md="11" align="center"
        >No aplica este componente en este modelo</v-col
      >
      <v-col align-self="center" align="center" cols="1" md="1">
        <v-icon
          class="fuel-component_icon"
          color="gray"
          dense
          size="16"
          v-if="isEditChecklist"
          @click.stop="checklistFuelData.notApply = !checklistFuelData.notApply"
          >fas fa-plus</v-icon
        >
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      labels: ["E", "1/4", "1/2", "3/4", "F"]
    };
  },
  props: ["isEditChecklist", "accessToEdit"],
  computed: {
    ...mapState("checklist", ["checklistFuelData"])
  }
};
</script>

<style scoped>
.fuel-component {
  size: 10px;
  border: 0.3px solid #a0a0a0;
}
.fuel-component_not-apply {
  background-color: lightgray;
}
.fuel-component_icon {
  padding: 0;
  margin: 0;
  transform: rotate(45deg);
}
</style>
